export const getPath = (path, cardSlug) => {
  return path.replace(':cardSlug', cardSlug);
};
export const getPathGroup = (path, groupSlug, topicSlug, cardSlug) => {
  return path
    .replace(':groupSlug', groupSlug)
    .replace(':topicSlug', topicSlug)
    .replace(':cardSlug', cardSlug);
};
